define(
    'viewmodels/secured/libraries/create/duplicate/confirm/confirm',[
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (ViewModel,dataProvider,i19n){

        var vm = new ViewModel(
        {
            id: '',
            i19n: i19n,

            libraryId: ko.observable(),
            name: ko.observable(),
            repositoryId: ko.observable(),
            repository: ko.observable(),
            listId: ko.observable(),
            list: ko.observable(),
            templateId: ko.observable(),
            template: ko.observable(),
            templateTellMeMoreLink: ko.observable('http://help.fileplan.com/hc/en-us/articles/203335490-Library-Settings-and-Folder-Templates'),
            access: ko.observable(),
            accessTellMeMoreLink: ko.observable('http://help.fileplan.com/hc/en-us/articles/203335580-Restricting-Access-to-a-Library'),

            isSendEmail: ko.observable(false)
        });

        vm.activate = function () {
            vm.libraryId('');
            vm.name('');
            vm.repositoryId('');
            vm.repository('');
            vm.listId('');
            vm.list('');
            vm.templateId('');
            vm.template('');
            vm.access('');
            vm.isSendEmail(false);
        };
        vm.confirm = function () {
            var d = $.Deferred();

            dataProvider.libraries
            .createDuplicate(vm.libraryId(), vm.name(), vm.listId(), vm.repositoryId(), vm.isSendEmail())
            .done(function (result) {
                d.resolve(result);

                //location.reload();
            })
            .fail(function (e) {
                d.reject(e);
            });

            return d.promise();
        };

        return vm;
    }
);
